import React from 'react';
import useCheckIfCurrentCompanyIsPECO from 'utils/Hooks/CompanySpecific/PECO/useCheckIfCurrentCompanyIsPECO';
import HotjarSnippet from 'Vendors/Hotjar/HotjarSnippet';

/**
 * Component that renders the Hotjar JS snippet with PECO customizations.
 */
function PecoHotjarSnippet(): React.ReactElement {
    const isProd = AUTH_TARGET === 'prod';
    const { isCurrentCompanyDetermined, idMatch: isPECOCurrentCompany } = useCheckIfCurrentCompanyIsPECO();
    return <>{isProd && isCurrentCompanyDetermined && isPECOCurrentCompany && <HotjarSnippet hotjarId="1379604" />}</>;
}

export default PecoHotjarSnippet;
